module.exports = __webpack_public_path__ + "static/media/ourearth.629e5af0.svg";